import React, { useCallback, useEffect, useState } from 'react';
import { Paper, Typography, Box, FormControl, InputLabel, Select, MenuItem, Button, DialogContent, TextField, Grid, FormControlLabel, Divider, Chip } from '@mui/material';
import jwtAuthAxios from 'app/services/auth/jwtAuth';
import CheckBoxOutlineBlankOutlinedIcon from '@mui/icons-material/CheckBoxOutlineBlankOutlined';
import useSwalWrapper from '@jumbo/vendors/sweetalert2/hooks';
import { Table, TableContainer, TableHead, TableBody, TableCell, TableRow, Dialog } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import { Add, AddBox, CheckBox, CheckBoxTwoTone, Delete, Edit, Square } from '@mui/icons-material';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Div from '@jumbo/shared/Div';
import { LoadingButton } from '@mui/lab';
import TableSkeleton from 'app/shared/widgets/TableSkeleton';
import useJumboAuth from '@jumbo/hooks/useJumboAuth';
const validationSchema = Yup.object().shape({
  FL_NAME: Yup.string().required('Name is required'),
  // Add more validation rules for other fields
});

function AddEditForm({ open, handleClose, item, fetchParamsData, data, selectedParamType, inventoryData = [], stdValue = [] }) {
  const swal = useSwalWrapper();
  const [isLoading, setIsLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      FL_ID: item?.FL_ID || '',
      FL_PARAM_TYPE: item?.FL_PARAM_TYPE || '',
      FL_NAME: item?.FL_NAME || '',
      FL_SHORT_NAME: item?.FL_SHORT_NAME || '',
      FL_GROUP_NAME: item?.FL_GROUP_NAME || '',
      FL_PC: item?.FL_PC === 1, // Convert 1 to true and 0 to false
      FL_RAP_PRICE: item?.FL_RAP_PRICE || '',
      FL_RAP_DISCOUNT_PER: item?.FL_RAP_DISCOUNT_PER || null,
      FL_STD_VALUR: item?.FL_STD_VALUR || '',
      FL_INVENTORY_TYPE: item?.FL_INVENTORY_TYPE?.split(',') || [],
      FL_SHORT_NO: item?.FL_SHORT_NO || 0,
      FL_IS_ACTIVE: item?.FL_IS_ACTIVE === 1, // Convert 1 to true and 0 to false
    },
    validationSchema,
    onSubmit: async (values) => {
      setIsLoading(true)
      // Convert boolean values back to 1 or 0
      const submittedData = await {
        ...values,
        FL_INVENTORY_TYPE: values.FL_INVENTORY_TYPE.join(','),
        FL_PC: values.FL_PC ? 1 : 0,
        FL_IS_ACTIVE: values.FL_IS_ACTIVE ? 1 : 0,
      };
      await jwtAuthAxios.post('master/addEdit', submittedData).then(async response => {
        if (response.data.status == 'success') {
          swal.fire({
            icon: 'success',
            text: response.data.message || 'Parmas Added',
          });
          await formik.resetForm();
          handleClose();
          fetchParamsData();
        } else {
          swal.fire({
            icon: 'error',
            text: response.data.message || 'Something Went Wrong',
          });
        }
      }).catch(e => {
        swal.fire({
          icon: 'error',
          text: 'Internal server error',
        });
        return false
      }).finally(() => {
        setIsLoading(false)
      })
      // Close the form after submission


    },
  });
  useEffect(() => {
    formik.setValues({
      FL_ID: item?.FL_ID || null,
      FL_NAME: item?.FL_NAME || '',
      FL_PARAM_TYPE: item?.FL_PARAM_TYPE || selectedParamType,
      FL_SHORT_NAME: item?.FL_SHORT_NAME || '',
      FL_GROUP_NAME: item?.FL_GROUP_NAME || '',
      FL_PC: item?.FL_PC == 1 ? true : false,
      FL_RAP_PRICE: item?.FL_RAP_PRICE || '',
      FL_RAP_DISCOUNT_PER: item?.FL_RAP_DISCOUNT_PER || null,
      FL_STD_VALUR: item?.FL_STD_VALUR || '',
      FL_INVENTORY_TYPE: item?.FL_INVENTORY_TYPE?.split(',') || [],
      FL_SHORT_NO: item?.FL_SHORT_NO || 0,
      FL_IS_ACTIVE: item?.FL_IS_ACTIVE == 1 ? true : false,
    });
  }, [item,selectedParamType]);



  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogContent>
        <Typography variant="h3" gutterBottom>
          {item?.FL_ID ? 'Edit Item' : 'Add Item'}
        </Typography>
        <Divider sx={{ mb: 3 }} />
        <form onSubmit={formik.handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                label="Parameter Type"
                name="FL_PARAM_TYPE"
                disabled={selectedParamType != null}
                value={formik.values.FL_PARAM_TYPE}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                fullWidth
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Name"
                name="FL_NAME"
                value={formik.values.FL_NAME}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.FL_NAME && Boolean(formik.errors.FL_NAME)}
                helperText={formik.touched.FL_NAME && formik.errors.FL_NAME}
                fullWidth
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Short Name"
                name="FL_SHORT_NAME"
                value={formik.values.FL_SHORT_NAME}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                fullWidth
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Group Name"
                name="FL_GROUP_NAME"
                value={formik.values.FL_GROUP_NAME}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                fullWidth
              />
            </Grid>

            {/* <CheckBox
            <Grid item xs={6}>
                  name="FL_PC"
                  checked={formik.values.FL_PC}
                  onChange={formik.handleChange}
            </Grid>
                /> */}


            {data.length > 0 &&<> <Grid item xs={6}>
              <InputLabel sx={{ mb: 0 }}>Rap Price</InputLabel>
              <Select
                name="FL_RAP_PRICE"
                value={formik.values.FL_RAP_PRICE}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                fullWidth
              >
                {data.map((data) => (
                  <MenuItem key={data.FL_NAME} value={data.FL_NAME}>
                    {data.FL_NAME}
                  </MenuItem>
                ))}</Select>
            </Grid>
            <Grid item xs={6}>
              <InputLabel sx={{ mb: 0 }}>Rap Discount Percentage</InputLabel>
              <Select
                label="Rap Discount Percentage"
                name="FL_RAP_DISCOUNT_PER"
                value={formik.values.FL_RAP_DISCOUNT_PER}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                fullWidth
              >
                {data.map((data) => (
                  <MenuItem key={data.FL_NAME} value={data.FL_NAME}>
                    {data.FL_NAME}
                  </MenuItem>
                ))}</Select>
            </Grid></>}
            {stdValue.length > 0 && <><Grid item xs={6}>
              <InputLabel sx={{ mb: 0 }}>Standard Value R</InputLabel>
              <Select
                label="Standard Value"
                name="FL_STD_VALUR"
                value={formik.values.FL_STD_VALUR}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.FL_STD_VALUR && Boolean(formik.errors.FL_STD_VALUR)}
                helperText={formik.touched.FL_STD_VALUR && formik.errors.FL_STD_VALUR}
                fullWidth
              >
                {stdValue.map((data) => (
                  <MenuItem key={data.STDVALUE} value={data.STDVALUE}>
                    {data.STDVALUE}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
              <Grid item xs={6}>

                <InputLabel sx={{ mb: 0}}>Inventory Type</InputLabel>
                <Select
                  label="Inventory Type"
                  name="FL_INVENTORY_TYPE"
                  value={formik.values.FL_INVENTORY_TYPE}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  multiple
                  fullWidth
                >
                  {inventoryData.map((data) => (
                    <MenuItem key={data.NAME} value={data.NAME}>
                      {data.NAME}
                    </MenuItem>
                  ))}
                </Select>
              </Grid></>}
            <Grid item xs={6}>
              <FormControl>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="FL_PC"
                      checked={formik.values.FL_PC}
                      onChange={formik.handleChange}
                      color="primary" // Set the color you want for the checkbox
                    />
                  }
                  label="Price Chart (PC)"
                />
              </FormControl>
              <FormControl>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="FL_IS_ACTIVE"
                      checked={formik.values.FL_IS_ACTIVE}
                      onChange={formik.handleChange}
                      color="primary" // Set the color you want for the checkbox
                    />
                  }
                  label="Is Active"
                />
              </FormControl>

              {/* <FormControl fullWidth>
                <InputLabel></InputLabel>
                <Checkbox
                  name="FL_IS_ACTIVE"
                  checked={formik.values.FL_IS_ACTIVE}
                  onChange={formik.handleChange}
                />
              </FormControl> */}
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Short Number"
                name="FL_SHORT_NO"
                value={formik.values.FL_SHORT_NO}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                fullWidth
              />
            </Grid>
          </Grid>
          <Divider sx={{ mb: 3, mt: 2 }} />
          <LoadingButton loading={isLoading} variant="contained" size='large' sx={{ mr: 3 }} color="primary" type="submit">
            Save
          </LoadingButton>
          <Button variant="outlined" size='large' color="secondary" onClick={handleClose}>
            Cancel
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
function AllParametersTab() {
  const [selectedParamType, setSelectedParamType] = useState(null);
  const [data, setData] = useState([]);
  const [inventoryData, setInventoryData] = useState([]);
  const [paramTypes, setParamTypes] = useState([]);
  const [stdValue, setStdValue] = useState([]);
  const [openAddEditForm, setOpenAddEditForm] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const swal = useSwalWrapper();
  const fetchParamsData = useCallback(async (value = null) => {
    setData([]);
    value == null && setSelectedParamType(null)
    jwtAuthAxios.get(`master/params${value != null ? '?type=DIAMOND&param=' + value : ''}`).then(data => {
      if (data.data.status === 'success') {
        if (value == null) {
          setParamTypes(data.data.rows);
          data?.data?.inventory && setInventoryData(data.data.inventory);
        } else {
          
          setData(data.data.rows)
          data?.data?.stdValue && setStdValue(data.data.stdValue)
        }
      }
    }).catch(e => {
      swal.fire({
        icon: 'error',
        text: 'Internal server error',
      });
    })
  }, []);


  useEffect(() => {
    fetchParamsData();
    
  }, []);

  const handleParamChange = async (event) => {
    setSelectedParamType(event.target.value);
    fetchParamsData(event.target.value)
  };

  // const uniqueParamTypes = [...new Set(data.map((param) => param.FL_PARAM_TYPE))];

  const handleOpenAddEditForm = (item) => {
    setSelectedItem(item);
    setOpenAddEditForm(true);
  };

  const handleAddEditFormClose = () => {
    setSelectedItem(null);
    setOpenAddEditForm(false);
  };


  return (
    <>
      <Paper elevation={3} style={{ padding: '20px' }}>
        <Grid container>
          <Grid item lg={6}>
            <Typography variant="h3" sx={{ mb: 3 }} gutterBottom>
              Diamond Parameter Master
            </Typography>
          </Grid>
          <Grid item lg={6}>
            <Div sx={{ display: 'flex', gap: '20px', justifyContent: 'end' }}><FormControl style={{ minWidth: 200, marginBottom: 20 }}>
              {selectedParamType == null && <InputLabel sx={{ mb: 0 }}>{paramTypes.length ==0 ?'Loading Data':'Parameter Type'}</InputLabel>}
              <Select
                value={selectedParamType}
                onChange={handleParamChange}
                sx={{ mb: '-20px' }}
                disabled={paramTypes.length ==0}
              >
                {paramTypes.map(({ PARAMTYPE }) => (
                  <MenuItem key={PARAMTYPE} value={PARAMTYPE}>
                    {PARAMTYPE}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
              <LoadingButton
                variant="contained"
                color="primary"
                loading={paramTypes.length ==0 }
                size='large'
                onClick={() => handleOpenAddEditForm({})}
              >
                Add New
              </LoadingButton></Div>
          </Grid>
        </Grid>
      </Paper>
      {selectedParamType != null && <ParameterInfo data={data} isStdVal={stdValue.length > 0} onEdit={handleOpenAddEditForm} />}
      <AddEditForm
        open={openAddEditForm}
        handleClose={handleAddEditFormClose}
        item={selectedItem}
        data={data}
        inventoryData={inventoryData}
        selectedParamType={selectedParamType}
        fetchParamsData={fetchParamsData}
        stdValue={stdValue}
      />
    </>
  );
}

function ParameterInfo({ data, onEdit, isStdVal }) {
  return (
    <TableContainer  sx={{ mt: 3 }} component={Paper}>
    {data.length >0 ? 
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell >ID</TableCell>
            <TableCell >NAME</TableCell>
            <TableCell >SHORT NAME</TableCell>
            <TableCell >GROUP NAME</TableCell>
            <TableCell >PC</TableCell>
            <TableCell >RAP PRICE</TableCell>
            <TableCell >RAP DISC PER</TableCell>
            {isStdVal && <><TableCell >STD VALUR</TableCell>
              <TableCell >INVENTORY TYPE</TableCell></>}
            <TableCell >IS ACTIVE</TableCell>
            <TableCell >ACTION</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((item, index) => (
            <TableRow key={index}>
              <TableCell>{index+1}</TableCell>
              <TableCell>{item.FL_NAME}</TableCell>
              <TableCell>{item.FL_SHORT_NAME}</TableCell>
              <TableCell>{item.FL_GROUP_NAME}</TableCell>
              <TableCell>{item.FL_PC == 1 ? <CheckBoxTwoTone /> : <CheckBoxOutlineBlankOutlinedIcon />}</TableCell>
              <TableCell>{item.FL_RAP_PRICE}</TableCell>
              <TableCell>{item.FL_RAP_DISCOUNT_PER}</TableCell>
              {isStdVal && <><TableCell>{item.FL_STD_VALUR}</TableCell>
                <TableCell>{item.FL_INVENTORY_TYPE}</TableCell></>}
              <TableCell>
                <Chip
                  color={item.FL_IS_ACTIVE == 1 ? 'success' : 'error'}
                  // onClick={()=>userEditHandler(user)}
                  // icon={<Edit fontSize='18px'/>}
                  label={item.FL_IS_ACTIVE == 1 ? 'Active' : 'Inactive'}

                /></TableCell>
              <TableCell>
                <Div> <Button
                  size="small"
                  color="secondary"
                  sx={{ px: 0, borderRadius: '50%', width: '32px', height: '32px', minWidth: 'auto' }}
                  onClick={() => onEdit(item)}
                >
                  <Edit />
                </Button>
                  <Button color="error" size="small" sx={{ px: 0, borderRadius: '50%', width: '32px', height: '32px', minWidth: 'auto' }}>
                    <Delete />
                  </Button></Div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>: <TableSkeleton cols={10} row={10}/>}
    </TableContainer>
  );
}


AllParametersTab.Modulename = 'PARAMS'
export default AllParametersTab;
